import {
  GET_COUPON_DETAIL_REQUEST,
  GET_COUPON_DETAIL_SUCCESS,
  GET_COUPON_DETAIL_FAILURE,
  GET_COUPON_CHANGE_ODDS_REQUEST,
  GET_COUPON_CHANGE_ODDS_SUCCESS,
  GET_COUPON_CHANGE_ODDS_FAILURE
} from 'Store/constants';

const initialState = {
  data: [],
  isLoading: false,
  error: null
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_COUPON_DETAIL_REQUEST:
      return { ...state, isLoading: true, error: null };
      
    case GET_COUPON_DETAIL_SUCCESS:
      return {
        data: action.payload,
        isLoading: false,
        error: null
      };

    case GET_COUPON_DETAIL_FAILURE:
      return { ...state, isLoading: false, error: action.payload };

    case GET_COUPON_CHANGE_ODDS_REQUEST:
      return { ...state, isLoading: true, error: null };
        
    case GET_COUPON_CHANGE_ODDS_SUCCESS:
      return {
        data: action.payload,
        isLoading: false,
        error: null
      };
    case GET_COUPON_CHANGE_ODDS_FAILURE:
      return { ...state, isLoading: false, error: action.payload };
    default:
      return state;
  }
};
